import Transaction from '@/models/Transaction'
import Api from '@/api'
import { each, find, findIndex } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {},
    pendingList: [],
    pendingListMeta: {},
    transactionDetails: null
  },

  mutations: {
    setTransactionList(state, { transactions, list }) {
      each(transactions, transaction => {
        const exist = find(state[list], { id: transaction.id })
        if (!exist) {
          state[list].push(new Transaction(transaction))
        }
      })
    },

    setTransactionListMeta(state, { meta, list }) {
      state[list + 'Meta'] = meta
    },

    setTransactionListItemDetails(state, review) {
      const index = findIndex(state.list, { id: review.id })
      state.list[index].body = review.body
    },

    clearTransactionList(state, list = 'list') {
      state[list] = []
      state[list + 'Meta'] = {}
    },

    setTransactionDetails(state, transaction) {
      if (transaction instanceof Transaction) {
        state.transactionDetails = transaction
      } else {
        state.transactionDetails = new Transaction(transaction)
      }
    },

    clearTransactionDetails(state) {
      state.transactionDetails = null
    }
  },

  actions: {
    async getTransactions({ commit }, params) {
      let query = Transaction.page(params.page || 1)
        .custom('my-transactions')
        .limit(params.limit)

      let list = 'list'
      if (params.filters) {
        if (params.filters.status) {
          let status = params.filters.status
          query.where('status', status)
          if (status === 'pending') {
            list = 'pendingList'
          }
        }

        if (params.filters.sorting) {
          query.orderBy(params.filters.sorting)
        }
      }

      const res = await query.get(params)

      commit('setTransactionList', { transactions: res.data, list: list })
      commit('setTransactionListMeta', { meta: res.meta, list: list })
    },

    async getTransactionDetails({ commit }, id) {
      const { data } = await Api.get(`my-transactions/${id}`)
      commit('setTransactionDetails', data.data)
    }
  }
}
